module.exports = "<li v-el:v v-if=\"loading\"><slot></slot></li>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Option.vue
// module id = 154
// module chunks = 0